import { RestService } from './../rest.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CadastroUsuario } from '../../entity/CadastroUsuario';
import { URL_API } from 'src/app/tools/URL';
import { catchError } from 'rxjs/internal/operators/catchError';
import { Observable, throwError } from 'rxjs';
import {  ERRO_DADOS_NAO_GRAVADOS } from 'src/app/tools/Mensagens';

@Injectable({
  providedIn: 'root'
})
export class PesquisarUsuarioService {

  constructor(private rest: RestService) { }

  findAll(usuario: CadastroUsuario, page: number, count: number) {

    return this.rest.post(`${URL_API.PATH_PESQUISAR_USUARIO}` + '/' + page + '/' + count, usuario).pipe(catchError(this.handleError));

  }

  findByName(nome: string) {

    return this.rest.get(`${URL_API.PATH_PESQUISAR_USUARIO_POR_NOME + '/' + nome }`);

  }

  findById(id: number) {

    return this.rest.get(`${URL_API.PATH_PESQUISAR_USUARIO_POR_ID + '/' + id }`);

  }

  handleError(error: HttpErrorResponse) {

    console.log(error);
    window.alert(ERRO_DADOS_NAO_GRAVADOS);
    return throwError(ERRO_DADOS_NAO_GRAVADOS);

  }

  desativarPorOperador(idUsuario): Observable <any> {
    return this.rest.put(`${URL_API.PATH_USUARIO}/operador/desativar/${idUsuario}`).pipe(
           catchError(this.handleError)
         );
  }

  reativarPorOperador(idUsuario): Observable <any> {
    return this.rest.put(`${URL_API.PATH_USUARIO}/operador/reativar/${idUsuario}`).pipe(
           catchError(this.handleError)
         );
  }

}
